export const TOGGLE_DIALOG = 'TOGGLE_DIALOG';

export const toggleDialog = name => {
  return { type: TOGGLE_DIALOG, payload: name };
};
